import React from "react";
import Box from "@mui/material/Box";

const AllCategories = () => {

    return (
        <Box sx={{display: 'flex'}}>
            <p>All Categories Page</p>
        </Box>
    );
}

export default AllCategories;
